import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, NgModule, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../shared.module';

@Component({
  selector: 'lp2-carousel-section-error',
  templateUrl: './carousel-section-error.component.html',
  styleUrls: ['./carousel-section-error.component.scss'],
})
export class CarouselSectionErrorComponent {
  @Input() title?: string;
  @Input() description?: string;
  @Input() buttonText?: string;
  @Output() buttonClick? = new EventEmitter<void>();
}



// WEBPACK FOOTER //
// ./ts/app/shared/carousel-section-error/carousel-section-error.component.ts